<template>
  <v-container fluid v-resize="onResize" class="px-0 py-0">
    <slot name="bar">
      <v-system-bar height="24">
        <span v-if="!!title"><span class="text-h6">{{ title }}</span></span>
        <v-spacer></v-spacer>
        <slot name="bar.right">
          <BaseTextSwitch
              v-if="showDeleted === null"
              v-model="showDeletedLocal"
              x-small
              on-text="show deleted"
              off-text="show undeleted"
              :color="showDeletedLocal ? 'red lighten-1': null"
              @input="selectedItems = []"
          ></BaseTextSwitch>
          <BaseDeleteIcon
              :value="true"
              v-if="showDeletedLocal && selectedItems.length > 0"
              @confirm="undeleteSelected()"
          ></BaseDeleteIcon>
<!--          <BasePurgeIcon-->
<!--              v-if="showDeletedLocal && selectedItems.length > 0"-->
<!--              @confirm="purgeSelected()"-->
<!--          ></BasePurgeIcon>-->
          <BaseDeleteIcon
              :value="false"
              v-if="!showDeletedLocal"
              :readonly="selectedItems.length === 0"
              @confirm="deleteSelected()"
          ></BaseDeleteIcon>
        </slot>
      </v-system-bar>
    </slot>
    <v-row v-if="!!itemList" no-gutters>
      <v-col :cols="leftCols">
        <v-data-table
            v-model="selectedItems"
            fixed-header
            :height="height"
            :headers="columns"
            :items="filterWithDeletedRole()"
            :single-select="singleSelect"
            :options.sync="options"
            :item-key="itemKey"
            :show-select="showSelect"
            :hide-default-footer="hideDefaultFooter"
            :hide-default-header="hideDefaultHeader"
            @click:row="handleClick"
            :item-class="itemRowBackground || defaultRowBackGround"
            :show-expand="showExpand"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            @current-items="onCurrentItems($event)"
            :footer-props="footerProps"
            :items-per-page="itemsPerPage"
        >
          <template v-slot:body.prepend="{ headers }">
            <slot name="body.prepend" :headers="headers"></slot>
          </template>
          <template v-slot:top>
            <slot name="top" :instance="this" :selectedItems="selectedItems">
              <v-toolbar flat dense :height="heightToolbar">
                <slot name="top.left" :instance="instance">
                </slot>
                <slot name="top.middle" :instance="instance">
                  <v-spacer></v-spacer>
                </slot>
                <slot name="top.right" :instance="instance">
                  <v-btn
                      small
                      class="mx-1"
                      @click.stop="openDialog(null, null)"
                  >
                    {{ $t('new_item') }}
                  </v-btn>
                </slot>
              </v-toolbar>
            </slot>
          </template>
          <template v-slot:header.data-table-expand="params">
            <v-icon v-if="expandedToggle===null" class="px-1 mx-0" small @click="setExpanded(0)">
              mdi-checkbox-blank-outline
            </v-icon>
            <v-icon v-if="expandedToggle===0" class="px-1 mx-0" small @click="setExpanded(1)">mdi-plus-box-outline
            </v-icon>
            <v-icon v-if="expandedToggle===1" class="px-1 mx-0" small @click="setExpanded(0)">mdi-minus-box-outline
            </v-icon>
          </template>
          <template v-for="header in columns" v-slot:[`item.${header.value}`]="{index, item}">
            <slot :name="[`item.${header.value}`]" :index="index" :item="item" :instance="instance"
                  :isExpanded="isExpanded(item)">
              <span v-if="header.type === 'bool'" class="d-flex justify-center">
                <v-icon small v-if="item[`${header.value}`]">mdi-check</v-icon>
              </span>
              <span v-else-if="header.type === 'date'">
                  {{ item[`${header.value}`] | moment("DD.MM.YY") }}
              </span>
              <span v-else-if="header.type === 'datetime'">
                  {{ item[`${header.value}`] | moment("DD.MM.YY HH:mm") }}
              </span>
              <span v-else>
                  {{ item[`${header.value}`] }}
              </span>
            </slot>
          </template>
          <template v-slot:item.data-table-expand="{expand, isExpanded}">
            <span class="d-flex justify-center">
            <v-icon v-if="!isExpanded" small @click="expand(true); expandedToggle=null">mdi-plus-box-outline</v-icon>
            <v-icon v-if="isExpanded" small @click="expand(false); expandedToggle=null">mdi-minus-box-outline</v-icon>
            </span>
          </template>
          <template v-slot:item.drag="{ item }">
            <div class="handle grab">
              <v-icon small class="ml-0">mdi-drag-variant</v-icon>
            </div>
          </template>
          <template v-slot:item.deleted="{ item }">
            <v-icon v-if="!!item.deleted" small color="red lighten-2">mdi-trash-can</v-icon>
          </template>
          <template v-slot:item.to_delete="{ item }">
            <BaseDeleteIcon v-model="item.deleted" small></BaseDeleteIcon>
          </template>
          <template v-slot:item.edit_drag_index="{ index, item }">
            <div class="handle grab"
                 :draggable="true"
                 @drop="onDropCopy($event, item)"
                 @dragstart="onStartDrag($event, item)"
                 @dragover.prevent
                 @dragenter.prevent
            >
              <v-chip small @click="openDialog(item, index)">{{ index + 1 }}</v-chip>
            </div>
          </template>
          <template v-slot:item.edit="{ index, item }">
            <v-icon small @click="openDialog(item, index)" color="edit_icon">mdi-pencil-outline</v-icon>
          </template>
          <template v-slot:footer>
            <slot name="footer" :selectedItems="selectedItems">
            </slot>
          </template>
        </v-data-table>
      </v-col>
      <v-col :cols="12 - leftCols">
        <slot name="detail"
              :current.sync="itemList[currentIndex]"
              :showDeleted="showDeletedComputed"
              :height="height"
              :readonly="readonly"
        >
        </slot>
      </v-col>
    </v-row>
    <v-dialog
        v-if="!!editComponentPath"
        v-model="dialogFlag"
        persistent
        :width="dialogWidth"
    >
      <component
          v-model="dialogItem"
          :is="currenEditItem"
          :dialog.sync="dialogFlag"
          :edited-item-common="editedItemCommon"
          @save="saveDialog"
          :page="dialogIndex + 1"
          :page-length="filterWithDeletedRole().length"
          @pagination="openDialog(dialogItem, $event - 1)"
          @action_for_child="$emit('action_for_child', $event)"
      ></component>
    </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import draggable from "vuedraggable";
import colorClass from "@/commonFunction/colorClassDict"
import Sortable from "sortablejs";
import {debounce} from "debounce";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import BasePurgeIcon from "@/components/Base/BasePurgeIcon";
import BaseTextSwitch from "@/components/Base/BaseTextSwitch";
import commonFunction from "@/commonFunction/commonFunction";

export default {
  name: 'BaseDetailTable',
  props: {
    height: {type: [Number], default: 800},
    heightToolbar: {type: [Number], default: 32},
    itemList: {default: () => []},
    filterFunction: {
      type: [Function], default(x) {
        return x.filter(x => true)
      }
    },
    editedItemCommon: {
      default: () => {
      }
    },
    columns: {
      type: [Array], default() {
        return []
      }
    },
    readonly: {type: [Boolean], default: false},
    hideDefaultFooter: {type: [Boolean], default: true},
    singleSelect: {type: [Boolean], default: true},
    showSelect: {type: [Boolean], default: true},
    showExpand: {type: [Boolean], default: false},
    singleExpand: {type: [Boolean], default: true},
    showDeleted: {type: [Boolean], default: null},
    hideDefaultHeader: {type: [Boolean], default: false},
    editComponentPath: {type: [String], default: null},
    title: {type: [String], default: null},
    itemKey: {type: [String], default: 'uid'},
    newItem: {
      type: [Object], default() {
        return {uid: uuidv4()}
      }
    },
    leftCols: {type: [Number], default: 12},
    itemRowBackground: {default: null},
    dialogWidth: {default: null},
    footerProps: {default: null},
    itemsPerPage: {default: -1},
    sortBy: {default: null},
  },

  components: {
    draggable,
    'add-component': () => import(self.editComponentPath),
    BaseDeleteIcon,
    BasePurgeIcon,
    BaseTextSwitch,
  },

  computed: {
    // dialogItem() {
    //   console.log('dialogItem', this.dialogIndex, this.filterWithDeletedRole())
    //   return this.filterWithDeletedRole()[this.dialogIndex]
    //   // if (this.currentItems.length > 0)
    //   //   return this.currentItems[this.dialogIndex]
    //   // else
    //   //   return {}
    // },
    currenEditItem: function () {
      if (this.editComponentPath) {
        // console.log('currenEditItem', this.editComponentPath)
        return () => import("@/components" + this.editComponentPath);
        // return() => import(this.newItemPass);
      }
    },
    showDeletedComputed() {
      if (this.showDeleted === null)
        return this.showDeletedLocal
      else
        return this.showDeleted
    },
  },

  watch: {
    itemList: {
      handler(newValue, oldValue) {
        // console.log('BaseDetailTable watch itemList', newValue, this.dialogIndex )
        this.selectedItems = []
        // if (!!this.dialogIndex && !!this.itemList)
        //   this.dialogItem = this.itemList[this.dialogIndex]
      },
      deep: true
    },
  },

  methods: {
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },
    setOrderByIndex(index, item) {
      console.log('setOrderByIndex', index, item)
      item.order = index
    },
    onCurrentItems(currentItems) {
      // console.log('onCurrentItems', currentItems)
      this.currentItems = currentItems
    },
    filterWithDeletedRole() {
      // console.log('filterWithDeletedRole', this.showDeletedComputed)
      if (this.itemList == null) return []
      if (this.showDeletedComputed)
        return this.filterFunction(this.itemList).filter(row => row.deleted === true)
      else
        return this.filterFunction(this.itemList).filter(row => row.deleted === false)
    },
    deleteSelected() {
      console.log('deleteSelected')
      this.selectedItems.forEach(row => row.deleted = true)
    },
    undeleteSelected() {
      console.log('undeleteSelected')
      this.selectedItems.forEach(row => row.deleted = false)
    },
    purgeSelected() {
      console.log('purgeSelected', this.selectedItems)
      for (let selected of this.selectedItems)
        for (let index=0; index < this.itemList.length; index++)
          if (selected.uid === this.itemList[index].uid && this.itemList[index].deleted === true) {
            this.itemList.splice(index, 1)
            break
          }
    },
    setExpanded(newToggle) {
      // console.log('setExpanded', this.expandedToggle)
      this.expandedToggle = newToggle
      this.expanded = []
      if (newToggle === 1) {
        this.itemList.forEach(row => this.expanded.push(row))
      }
      if (newToggle === 0) {
        this.expanded = []
      }
    },
    isExpanded(item) {
      // console.log('isExpanded', item, this.expanded.includes(item))
      return this.expanded.includes(item)
    },
    handleClick(item) {
      // console.log('row click', item)
      this.currentItem = item
      let current = this.currentItem || this.itemList[0]
      this.currentIndex = this.itemList.findIndex(function (row) {
        return row.uid === current.uid
      })
    },
    openDialog(item = null, index = null) {
      // console.log('openDialog edit', item, index)
      this.dialogIndex = index
      // this.dialogItem = item
      this.dialogFlag = true
      this.dialogItem = this.currentItems[this.dialogIndex]
    },
    saveDialog(item) {
      // console.log('BaseDetailTable saveDialog', this.itemList, item)
      if (!commonFunction.updateDeepDictionary(this.itemList, item)) {
        item.order = this.itemList.length
        this.itemList.push(item)
        // console.log('BaseDetailTable saveDialog push', this.itemList, item)
      }
      this.$emit('update:itemList', structuredClone(this.itemList))
      this.dialogFlag = false
    },
    onKey(event) {
      // console.log('key', event)
      let current = this.currentItem || this.itemList[0]
      this.currentIndex = this.itemList.findIndex(function (row) {
        return row.uid === current.uid
      })
      if (this.currentIndex === -1) this.currentIndex = 0
      if (event.target.nodeName !== 'TEXTAREA' &&
          event.key === "ArrowUp" && this.currentIndex > 0) {
        this.currentIndex -= 1
        this.currentItem = this.itemList[this.currentIndex]
      }
      if (event.target.nodeName !== 'TEXTAREA' &&
          event.key === "ArrowDown" && this.currentIndex < this.itemList.length - 1) {
        this.currentIndex += 1
        this.currentItem = this.itemList[this.currentIndex]
      }
    },
    defaultRowBackGround(item) {
      if (!!this.itemList && !!item.uid && this.itemList[this.currentIndex].uid === item.uid)
        return 'row_selected'
    },
    onStartDrag(event, item) {
      console.log('onStartDrag', event)
      for(let i in this.itemList) {
        if (this.itemList[i].uid === item.uid) {
          // Add an element to the dictionary
          event.dataTransfer.setData('fromIndex', i)
          break; // If you want to break out of the loop once you've found a match
        }
      }
      event.dataTransfer.effectAllowed = 'copyMove'
    },
    onDropCopy(event, item) {
      let fromIndex = event.dataTransfer.getData('fromIndex')
      for(let index in this.itemList) {
        if (this.itemList[index].uid === item.uid) {
          console.log('onDrop', event, index, fromIndex)
          let element = this.itemList.splice(fromIndex, 1)[0]
          this.itemList.splice(index, 0, element);
          break; // If you want to break out of the loop once you've found a match
        }
      }
      for(let index in this.itemList) {
        this.itemList[index].order = index
      }
    },
    // saveOrder({newIndex, oldIndex}) {
    //   const row = this.itemList.splice(oldIndex, 1)[0]
    //   this.itemList.splice(newIndex, 0, row)
    //   for (let [index, item] of this.itemList.entries())
    //     item.order = index
    // },
  },

  async mounted() {
    this.selectedItems = []
    let table = document.querySelector(".v-data-table__wrapper tbody")
    // Sortable.create(table, {handle: ".handle", sort: true, onUpdate: this.saveOrder})
  }
  ,

  created() {
    // console.log('created', this.itemId, this.props, this.$route.params)
    window.addEventListener('keyup', this.onKey)
  },
  destroyed() {
    window.removeEventListener("keyup", this.onKey);
  },

  data() {
    return {
      self: this,
      instance: this,
      taskModel: null,
      dialogFlag: false,
      dialogIndex: null,
      dialogItem: null,
      showDeletedLocal: false,
      selectedItems: [],
      expanded: [],
      expandedToggle: null,
      currentIndex: 0,
      currentItems: [],
      options: {
        page: 1,
        // itemsPerPage: this.itemsPerPage,
        sortBy: [this.sortBy],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
      },
      currentItem: null,
    }
  }
}
</script>

<style scoped>
.border {
  border: 1px dotted darkblue;
}

.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

.not-text-transform {
  text-transform: none !important;
}

.row_selected {
  border: 2px solid darkblue !important;
}


</style>

<i18n>
{
  "en": {
    "new_item": "New"
  },
  "de": {
    "new_item": "New"
  }
}
</i18n>
